// IssueReg.js

import { useState, useEffect, useRef, useCallback } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/CommonCtx';
import { getPosition } from '../contexts/CommonFunc';
import Creatable from 'react-select/creatable';
//import Creatable, { useCreatable } from 'react-select/creatable';
import axios from 'axios';
import moment from 'moment';
import { Editor } from '@tinymce/tinymce-react';
import PulseLoader from 'react-spinners/PulseLoader';
//import { useTheme } from "@emotion/react";
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
//import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
//import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
//import Paper from '@mui/material/Paper';
//import Avatar from '@mui/material/Avatar';
//import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
//import TextField from '@mui/material/TextField';
//import FormControlLabel from '@mui/material/FormControlLabel';
//import InputLabel from '@mui/material/InputLabel';
//import Checkbox from '@mui/material/Checkbox';
//import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
//import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Modal from '@mui/material/Modal';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import BottomNavigation from '@mui/material/BottomNavigation';

const IssueReg = (props) => {
    //console.log('pano_props', props);

    // loading
    const [ loading, setLoading ] = useState(false);

    // snackbar
    const [success, setSuccess] = useState(false);
    const [failed, setFailed] = useState(false);
   
    // selected tab
    const [ tab, setTab ] = useState('1');

    // common context
    const { user, ml, mode, camera, ppms, port } = useAuth();

    // issue
    //const issueRef = useRef(null);
    const issueList = useRef([]);
    const issueData = useRef({});
    //const issueValue = useRef('');
    //const [ issue, setIssue ] = useState('');
    const [ issueSel, setIssueSel ] = useState(null);
    const [ issueOpts, setIssueOpts ] = useState([]);

    // issue status
    const [ issueStat, setIssueStat ] = useState('STATUS_ACTIVE');

    // camera & gallery
    const fileImage = useRef('');
    const fileGallery = useRef('');
    const fileInputImage = useRef(null);
    const fileInputGallery = useRef(null);
    
    // tabs element
    const elTabs = useRef(null);

    // all project list
    const projs = useRef([]);
    // selected project
    const [ proj, setProj ] = useState('');

    // save button disabled
    const [ btnSave, setBtnSave ] = useState(true);

    // editor
    const editorRef = useRef(null);
    const selectRef = useRef('issueRegist')
    const contIssue = useRef('');
    const contResult = useRef('');
    const [ editorSelect, setEditorSelect ] = useState('issueRegist');
    const [ editorLang, setEditorLang ] = useState('en');
    const [ initContent, setInitContent ] = useState('');
    //const [ editorContent, setEditorContent ] = useState(initContent ?? '');

    const editorPlugins = [
        'accordion', 'advlist', 'anchor', 'autolink', 'autosave', 'charmap', 'code', 'codesample', 'directionality', 'emoticons',
        'fullscreen', 'help', 'image', 'importcss', 'insertdatetime', 'link', 'lists', 'media', 'nonbreaking', 'pagebreak', 'preview', 'quickbars',
        'save', 'searchreplace', 'table', 'visualblocks', 'visualchars', 'wordcount'
        // 'autoresize', 'template'
    ];
    const editorToolbar = `
        undo redo forecolor backcolor bold preview fullscreen
    `;
        //undo redo | fontfamily fontsize | forecolor backcolor | bold italic underline strikethrough | alignjustify alignleft aligncenter alignright | bullist numlist | lineheight | table tabledelete | charmap | link customimage media customfile | preview fullscreen
    // styles blocks emoticons image

    //const font_family = '굴림체=Gulim; 돋움체=Dotum; 바탕체=Batang; 궁서체=Gungsuh; 새굴림="New Gulim"; 맑은고딕="Malgun Gothic"; 나눔고딕=nanumgothic; 나눔바른고딕=nanumbarungothic; 나눔명조=Nanum Myoungjo; 나눔붓글씨=nanumbrushscript; Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua, palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma, arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats;';
    const fontFamily = 'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua, palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma, arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats;';

    const fontSize = '8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 18pt 19pt 20pt 24pt 36pt 48pt';
    const editorHeight = '40vh';
    const editorMinHeight = 300;
   
    const editorImgConf = {
        title: ml.IMAGE_IN_EDIT,
        body: {
            type: 'panel',
            items: [
                { type: 'input', name: 'filename', label: ml.FILE_NAME, enabled: false },
                { type: 'input', name: 'url', label: 'URL', enabled: false },
                { type: 'sizeinput', name: 'imgSize', label: 'Dimensions', enabled: true },
                //{ type: 'button', name: 'capture', text: 'Capture', buttonType: 'primary', enabled: true, maximized: true, onClick: function() {} },
                { type: 'dropzone', name: 'imgDropzone' } //, label: 'Dropzone' }
            ]
        },
        buttons: [
            { type: 'cancel', name: 'closeButton', text: ml.CANCEL },
            { type: 'submit', name: 'submitButton', text: ml.SAVE, buttonType: 'primary', enabled: false }
        ],
        onChange: async(dialogApi, details) => {
            const data = dialogApi.getData();
            //console.log('change', dialogApi, data, details);

            if (details.name === 'imgSize') {
            };

            if (details.name === 'imgDropzone') {
                let imgfile = data.imgDropzone[0];
                //console.log('imgfile', imgfile);
                dialogApi.setData({ filename: imgfile.name });

                let formData = new FormData();
                formData.append('file', imgfile);
                formData.append('filename', imgfile.name);
                //console.log(formData);

                const url = `${ppms}:${port}/appms/up/issue`;
                const res = await axios.post(url, formData, { 'Content-Type': false, processData: false, enctype: 'multipart/form-data', withCredentials: true });
                //console.log('up_res', res);
                if (res.data !== undefined && res.data !== '') {
                    //console.log('up_data', res.data.ok);

                    // set url
                    let src = '/' + res.data;
                    dialogApi.setData({ url: src });

                    // set size
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        //const blob = new Blob([reader.result]);
                        //const url = URL.createObjectURL(blob, {type: imgfile.type })

                        let _URL = window.URL || window.webkitURL;
                        let objURL = _URL.createObjectURL(imgfile);
                        let img = new Image();
                        img.onload = () => {
                            let width = img.naturalWidth; //this.width;
                            let height = img.naturalHeight; //this.height;
                            //console.log('img', img, img.height, img.naturalHeight);

                            _URL.revokeObjectURL(objURL);

                            // set data
                            //dialogApi.setData({ imgSize: { width: width, height: height } });
                            dialogApi.setData({ imgSize: { width: `${width}`, height: `${height}` } });

                            // enable submit
                            dialogApi.setEnabled('submitButton', 'enable');
                        };
                        //img.src = e.target.result; //url;
                        img.src = objURL;
                    };
                    reader.readAsDataURL(imgfile);
                    //reader.readAsArrayBuffer(imgfile);
                } else {
                    dialogApi.setData({ url: 'Failed!' });
                };
            };
        },
        onAction: (dialogApi, details) => {
            //console.log('action', details);
        },
        onSubmit: (api) => {
            //console.log('img', api);
            const data = api.getData();
            //console.log('submit', data);

            let content = `<img src="${data.url}" width="${data.imgSize.width}" height="${data.imgSize.height}" />`;
            editorRef.current.execCommand('mceInsertContent', false, content);
            api.close();
        }
    };

    const editorFileConf = {
        title: ml.FILE_ATTACH,
        body: {
            type: 'panel',
            items: [
                //{ type: 'urlinput', name: 'fileUrl', filetype: 'file', label: 'URL', //enabled: false },
                { type: 'input', name: 'fileUrl', label: 'URL', enabled: false },
                {
                    type: 'htmlpanel',
                    html: `
                        <input type="file" accept="*" name="uploadfile" class="tox-textfield" id="upload-file" onchange="uploadFileChange(event, 'upload-file');" />
                        <div style="height: 5px;"></div>
                        <div class="tox-dropzone-container"><div class="tox-dropzone" ondrop="fileDropHandler(event, 'upload-file');"><p>Drop a file here</p></div>
                    `
                }
            ]
        },
        buttons: [
            { type: 'cancel', name: 'closeButton', text: ml.CANCEL },
            { type: 'submit', name: 'submitButton', text: ml.SAVE, buttonType: 'primary', enabled: false }
        ],
        onChange: (dialogApi, details) => {
            //const data = dialogApi.getData();
            //console.log('change', data, details);
        },
        onAction: (dialogApi, details) => {
            //console.log('action', details);
        },
        onSubmit: (api) => {
            const data = api.getData();
            //console.log('submit', data);

            let orgFile = data.fileUrl.split(/_/).slice(1).join('_');
            let content = `
                <p><a href="${data.fileUrl}" rel="nofollow" download="${orgFile}" style="border: #ced4da solid 1px; background-color: #e9ecef; padding: 4px; border-radius: 5px;" onclick="window.parent.postMessage({ 'from': 'child', 'type': 'download', src: '${data.fileUrl}', name: '${orgFile}' }, '*');">첨부: ${orgFile}</a></p><br>
            `;
            //let content = `<br><button value="${data.fileUrl}">첨부: ${orgFile}</button><br>`;

            editorRef.current.execCommand('mceInsertContent', false, content);
            api.close();
        }
    };

    const editorInit = {
        language: editorLang,
        height: editorHeight,
        min_height: editorMinHeight,
        //autoresize_min_height: height,
        //autoresize_max_height: 1000,
        //autoresize_bottom_margin: 50,
        //allow_conditional_comments: true,
        //resize: true,
        font_family_formats: fontFamily,
        font_size_formats: fontSize,
        menubar: false,
        statusbar: false,
        plugins: editorPlugins,
        toolbar_mode: 'sliding', //'wrap',
        toolbar: editorToolbar,
        mobile: {
            toolbar_mode: 'scrolling',
            //theme: 'mobile',
        },
        contextmenu: false,
        quickbars_insert_toolbar: false,
        quickbars_selection_toolbar: false,
        quickbars_image_toolbar: false,
        editimage_toolbar: false,
        link_context_toolbar: false,
        convert_urls: false,
        //image_title: true,
        automatic_uploads: false,
        media_alt_source: false,
        media_poster: false,
        extended_valid_elements: 'a[href|style|onclick]',
        //extended_valid_elements: 'a[href|rel|style|download|target|onclick|click]',
        //extended_valid_elements: 'p[onclick]',
        promotion: false,
        setup: (editor) => {
            editor.ui.registry.addButton('customimage', {
                tooltip: ml.IMAGE_IN_EDIT,
                icon: 'image',
                onAction: () => {
                    let instanceApi = editor.windowManager.open(editorImgConf);
                    instanceApi.focus('cancelButton');
                }
            });
            editor.ui.registry.addButton('customfile', {
                tooltip: ml.FILE_ATTACH,
                icon: 'new-document',
                //icon: 'document-properties',
                onAction: () => {
                    let instanceApi = editor.windowManager.open(editorFileConf);
                    instanceApi.focus('cancelButton');
                }
            });
            editor.on('ExecCommand', (event) => {
                const command = event.command;
                if (command === 'mceMedia') {
                    const tablist = document.querySelectorAll('div[role="tablist"]');
                    tablist.forEach(tab => { tab.style.padding = 0; });

                    const tabEl = document.querySelectorAll('div[role="tablist"] .tox-tab');
                    tabEl.forEach(tab => {
                        if (tab.innerText === ml.INSERT) {
                            tab.style.display = 'none';
                        } else if (tab.innerText === ml.GENERAL) {
                            //tab.innerText = '';
                            tab.style.display = 'none';
                        }
                    });
                }
            });
        },
        //content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px; line-height: 1 }'
        content_style: 'body { font-size: 14px; line-height: 1.2 }'
    };

    const setEditorLangs = useCallback(() => {
        if (ml.LANG === 'ko') {
            setEditorLang('ko_KR');
        } else {
            setEditorLang('en');
        };
    }, [ ml.LANG ]);

    const getProjects = useCallback(async() => {
        try {
            const url = `${ppms}:${port}/appms/projs`;
            const res = await axios.get(url, { withCredentials: true });
            //console.log('projs_res', res);
            projs.current = res.data;
            if (res.data.length > 0) {
                //setProj(res.data[0].proj_cd);
                //setProj(res.data[0].proj_id);
                return res.data[0].proj_id;
            } else {
                return null;
            }
        } catch (err) {
            console.log(err);
        }
    }, [ ppms, port ]);

    const getIssueList = useCallback(async(proj_id) => {
        try {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            let data = new URLSearchParams({
                proj_id: -1, // all proj_id
                timezone: timezone
            });
            //console.log('data', data);
            const url = `${ppms}:${port}/appms/issues`;
            //const res = await axios.get(url, { withCredentials: true });
            const res = await axios.post(url, data, { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', withCredentials: true });
            //console.log('issue_res', res.data);

            issueList.current = res.data;
            //let list = res.data.filter(x => Number(x.proj_id) === Number(proj_id));
            //console.log('list', list);
            let opts = [];
            for (let i = 0; i < res.data.length; i++) {
                //console.log('res.data', res.data[i], res.data[i].proj_id, proj_id);
                if (Number(res.data[i].proj_id) === Number(proj_id)) {
                    let opt = {
                        value: res.data[i].seq,
                        label: res.data[i].issue
                    };
                    //console.log('opt', opt);
                    opts.push(opt);
                };
            };
            //console.log('opts', proj_id, opts);
            setIssueOpts(opts);
            //if (res.data.length > 0) {
            //    //setIssue(res.data[0].issue);
            //    return res.data[0].issue;
            //} else {
            //    return null;
            //}
        } catch (err) {
            console.log(err);
        }
    }, [ ppms, port ]);

    const getIssueData = useCallback(async() => {
        try {
            if (issueSel === null) return;

            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            let idx = '';
            if (issueSel !== null && (issueSel.__isNew__ === undefined || issueSel.__isNew__ === false)) idx = issueSel.value; 
            let data = new URLSearchParams({
                seq: idx, 
                proj_id: proj,
                timezone: timezone
            });
            //console.log('data', data);

            const url = `${ppms}:${port}/appms/issues`;
            const res = await axios.post(url, data, { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', withCredentials: true });
            //console.log('issue_data', res.data);
            if (res.data.length > 0) {
                issueData.current = res.data[0];
                contIssue.current = res.data[0].content;    
                contResult.current = res.data[0].result;
                if (selectRef.current !== null) {
                    if (selectRef.current === 'issueRegist') {
                        setInitContent(contIssue.current);
                    } else if (selectRef.current === 'issueResult') {
                        setInitContent(contResult.current);
                    };
                };
            } else {
                issueData.current = '';
                contIssue.current = '';
                contResult.current = '';
                setInitContent('');
            };
        } catch (err) {
            console.log(err);
        }
    }, [ ppms, port, proj, issueSel ]);

    const handleProjs = (e) => {
        //console.log('handle', e);
        setProj(e.target.value);

        let opts = [];
        for (let i = 0; i < issueList.current.length; i++) {
            if (issueList.current[i].proj_id === Number(e.target.value)) {
                let opt = {
                    value: issueList.current[i].seq,
                    label: issueList.current[i].issue
                };
                opts.push(opt);
            };
        };
        setIssueOpts(opts);
        setIssueSel(null);
        setInitContent('');
        contIssue.current = '';
        contResult.current = '';
    };

    const handleSave = (e) => {
        //console.log('handle', e, contIssue.current, contResult.current);

        (async() => {
            setLoading(true);

            try {
                let pos = await getPosition();

                let url = `${ppms}:${port}/appms/issup`;

                const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                //console.log(timezone);

                let data;
                let idx = '';
                let lon = pos.coords.longitude;
                let lat = pos.coords.latitude;
                if (issueSel !== null && (issueSel.__isNew__ === undefined || issueSel.__isNew__ === false)) {
                    idx = issueSel.value; 
                    lon = '';
                    lat = '';
                };

                if (tab === '1') {
                    data = new URLSearchParams({
                        seq: idx,
                        issue: issueSel.label,
                        content: contIssue.current ? contIssue.current : '',
                        result: contResult.current ? contResult.current : '',
                        proj_id: proj,
                        area_id: '',
                        lon: lon,
                        lat: lat,
                        status: issueStat,
                        time: moment().format('YYYY-MM-DD HH:mm:ss'),
                        timezone: timezone
                    });
                };
                //console.log('data', data);

                const res = await axios.post(url, data, { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', withCredentials: true });
                //console.log('upload_res', res);
                setLoading(false);
                if (res.data !== undefined && res.data !== null && res.data !== '') {
                    //console.log('upload_data', res.data);
                    setSuccess(true);
                    getIssueList(proj);
                } else {
                    setFailed(true);
                };

                if (tab === '1') {
                    //filePano.current = '';
                    setBtnSave(true);
                };

            } catch(err) {
                console.log(err);
                setLoading(false);
                setFailed(true);
            }
        })();
    };

    const handleChangeTab = (e, newValue) => {
        setTab(newValue);

        if (elTabs.current !== null) {
            //elTabs.current.setAttribute('data-tab', newValue);
        };

        if (newValue === '1') {
        };
    };

    //const handleChangeSelect = (e, newValue) => {
    //    setIssueSel(newValue);
    //    console.log('selchange', issueSel, newValue);
    //};

    const handleClickImage= (e) => {
        if (tab === '1') {
            //console.log('click', e, fileInputPano);
            e.target.value = ''; //null;
        };
    };

    const handleClickFile= (e) => {
        if (tab === '1') {
            //console.log('click', e, fileInputPano);
            e.target.value = ''; //null;
        };
    };

    const saveImgFile = async(imgfile) => {
        let formData = new FormData();
        formData.append('file', imgfile);
        formData.append('filename', imgfile.name);
        //console.log(formData);

        const url = `${ppms}:${port}/appms/up/issue`;
        const res = await axios.post(url, formData, { 'Content-Type': false, processData: false, enctype: 'multipart/form-data', withCredentials: true });
        //console.log('up_res', res);
        if (res.data !== undefined && res.data.link !== undefined && res.data.link !== '') {
            //console.log('up_data', res.data.link);

            // set url
            let src = `${ppms}:${port}/${res.data.link}`;
            //console.log('src', src);

            // set size
            const reader = new FileReader();
            reader.onload = (e) => {
                //const blob = new Blob([reader.result]);
                //const url = URL.createObjectURL(blob, {type: imgfile.type })

                let _URL = window.URL || window.webkitURL;
                let objURL = _URL.createObjectURL(imgfile);
                let img = new Image();
                img.onload = () => {
                    let width = img.naturalWidth; //this.width;
                    let height = img.naturalHeight; //this.height;
                    //console.log('img', img, img.height, img.naturalHeight);

                    _URL.revokeObjectURL(objURL);

                    //console.log('editorWidth', editorRef.current.getBody().clientWidth, editorRef.current);
                    let diff = 4;
                    let editWidth = editorRef.current.getBody().clientWidth;
                    if ((width-diff) > editWidth || (height-diff) > editWidth) {
                        width = editWidth - diff;
                        height = width;
                    };

                    let content = `<img src="${src}" width="${width}" height="${height}" />`;
                    //editorRef.current.execCommand('mceInsertContent', false, content);
                    editorRef.current.focus();
                    editorRef.current.selection.select(editorRef.current.getBody(), true);
                    editorRef.current.selection.collapse(false);
                    editorRef.current.focus();
                    editorRef.current.insertContent(content);
                    initEditorContent(editorRef.current.getContent());
                };
                img.src = objURL;
            };
            reader.readAsDataURL(imgfile);

        } else {
            //dialogApi.setData({ url: 'Failed!' });
        };
    };

    const saveLinkFile = async(linkfile) => {
        let formData = new FormData();
        formData.append('file', linkfile);
        formData.append('filename', linkfile.name);
        //console.log(formData);

        const url = `${ppms}:${port}/appms/up/issue`;
        const res = await axios.post(url, formData, { 'Content-Type': false, processData: false, enctype: 'multipart/form-data', withCredentials: true });
        //console.log('up_res', res);
        if (res.data !== undefined && res.data.link !== undefined && res.data.link !== '') {
            //console.log('up_data', res.data.link);

            // set url
            let src = `${ppms}:${port}/${res.data.link}`;
            //console.log('src', src);
            let fname = res.data.link.split('/').pop();
            let orgFile = fname.split(/_/).slice(1).join('_');
            let content = `
                <p><a href="${src}" rel="nofollow" download="${orgFile}" style="" onclick="window.parent.postMessage({ 'from': 'child', 'type': 'download', src: '${src}', name: '${orgFile}' }, '*');">${ml.ATTACHMENT}: ${orgFile}</a></p><br>
            `;
                //<p><a href="${src}" rel="nofollow" download="${orgFile}" style="border: #ced4da solid 1px; background-color: #e9ecef; padding: 4px; border-radius: 5px;" onclick="window.parent.postMessage({ 'from': 'child', 'type': 'download', src: '${src}', name: '${orgFile}' }, '*');">${ml.ATTACHMENT}: ${orgFile}</a></p><br>
            //let content = `<br><button value="${data.fileUrl}">첨부: ${orgFile}</button><br>`;

            //editorRef.current.execCommand('mceInsertContent', false, content);
            editorRef.current.focus();
            editorRef.current.selection.select(editorRef.current.getBody(), true);
            editorRef.current.selection.collapse(false);
            editorRef.current.focus();
            editorRef.current.insertContent(content);
            initEditorContent(editorRef.current.getContent());

        } else {
            //dialogApi.setData({ url: 'Failed!' });
        };
    };

    const handleChangeImage = (e) => {
        if (tab === '1') {
            //console.log('changeImage', e, fileInputImage);
            //e.preventDefault();

            if (e.target && e.target.files && e.target.files.length > 0 && e.target.files[0]) {
                fileImage.current = e.target.files[0];
                saveImgFile(e.target.files[0]);
            } else {
                //fileImage.current = '';
                //saveImgFile('');
            };
            //e.target.value = ''; // null;
        };
    };

    const handleChangeFile = (e) => {
        if (tab === '1') {
            //console.log('changeFile', e, fileInputPano);
            //e.preventDefault();

            if (e.target && e.target.files && e.target.files.length > 0 && e.target.files[0]) {
                fileGallery.current = e.target.files[0];
                saveLinkFile(e.target.files[0]);
            } else {
                //fileGallery.current = '';
                //saveLinkFile('');
            };
            //e.target.value = ''; // null;
        };
    };

    //const handleChangeIssue = (e) => {
    //    //console.log('change', e.target.value, issue, issueRef.current);
    //    if (tab === '1') {
    //        //setIssue(e.target.value);
    //        //setIssue(e.target.value.normalize('NFC'));
    //        //setIssue(issueRef.current.focus());
    //        issueValue.current = e.target.value;
    //    };
    //};

    //const handleFocusIssue = (e) => {
    //    //console.log('focus', e);
    //    if (tab === '1') {
    //        //setIssue(issueValue.current);
    //    };
    //};

    //const handleBlurIssue = (e) => {
    //    //console.log('blur', e);
    //    if (tab === '1') {
    //        setIssue(issueValue.current);
    //    };
    //};

    //const handleKeyDown = (e) => {
    //    if (e.nativeEvent.isComposing) {
    //        e.stopPropagation();
    //    };
    //};

    const handleIssueStat = (e) => {
        setIssueStat(e.target.value);
    };

    const handleBlur = (e) => {
        initEditorContent();
    };

    const handleEditorChange = (newValue, editor) => {
        if (editorSelect === 'issueRegist') {
            //contIssue.current = editorRef.current.getContent();
            contIssue.current = newValue;
            //console.log('contIssue', contIssue.current, editorRef.current.getContent());
            //editorRef.current.setDirty(false);
        } else if (editorSelect === 'issueResult') {
            //contResult.current = editorRef.current.getContent();
            contResult.current = newValue;
            //console.log('contResult', contResult.current, editorRef.current.getContent());
            //editorRef.current.setDirty(false);
        };
    };

    const handleEditorSelect = (e, newValue) => {
        //console.log('editsel', e, newValue);
        if (!newValue) return;

        selectRef.current = newValue;
        setEditorSelect(newValue);
        //console.log('current', newValue, contIssue.current, contResult.current, editorRef.current);
        if (newValue === 'issueRegist') {
            contResult.current = editorRef.current.getContent();
            //editorRef.current.execCommand('mceNewDocument');
            //editorRef.current.execCommand('mceSetContent', false, contIssue.current);
            //editorRef.current.execCommand('mceCleanup');
            //editorRef.current.setDirty(false);
            //editorRef.current.setContent(contIssue.current);
            setInitContent(contIssue.current);
            //console.log('issueRegist', editorRef.current.getContent());
        } else if (newValue === 'issueResult') {
            contIssue.current = editorRef.current.getContent();
            //editorRef.current.execCommand('mceNewDocument');
            //editorRef.current.execCommand('mceSetContent', false, contResult.current);
            //editorRef.current.execCommand('mceCleanup');
            //editorRef.current.setDirty(false);
            //editorRef.current.setContent(contResult.current);
            setInitContent(contResult.current);
            //console.log('issueResult', editorRef.current.getContent());
        }
    };

    const initEditorContent = (content) => {
        if (editorRef.current !== null && selectRef.current !== null) {
            if (selectRef.current === 'issueRegist') {
                if (content) contIssue.current = content;
                //contIssue.current = editorRef.current.getContent();
                //console.log('effect-contIssue', contIssue.current, editorRef.current.getContent());
                //editorRef.current.setDirty(false);
                setInitContent(contIssue.current);
            } else if (selectRef.current === 'issueResult') {
                if (content) contResult.current = content;
                //contResult.current = editorRef.current.getContent();
                //console.log('effect-contResult', contIssue.current);
                //editorRef.current.setDirty(false);
                setInitContent(contResult.current);
            };
        };
    };

    const downloadFile = (src, name) => {
        const link = document.createElement('a');
        //link.href = URL.createObjectURL(blob);
        link.href = src;
        //link.download = name;
        link.setAttribute('download', name);
        link.style.display = 'none';
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        //delete link;
    };

    const handleMessage = useCallback((e) => {
        if (e.data.from === 'child') {
            if (e.data.type === 'download') {
                downloadFile(e.data.src, e.data.name);
            }
        }
    }, []);

    useEffect(() => {
        //window.addEventListener('message', handleMessage);

        return () => {
            //window.removeEventListener('message', handleMessage);
        };
    }, [ handleMessage ]);

    useEffect(() => {
        //console.log('issueSel', issueSel);
        getIssueData();
    }, [ getIssueData ]);

    //useEffect(() => setEditorContent(initContent ?? ''), [initContent]);

    //useEffect(() => {
    //    //if (issue !== '' && initContent !== '' && contIssue.current !== '') {
    //    if (issue !== '') {
    //        setBtnSave(false);
    //    };
    //}, [ issue ]);
    
    useEffect(() => {
        //if (issue !== '' && initContent !== '' && contIssue.current !== '') {
        if (issueSel !== null) {
            setBtnSave(false);
        } else {
            setBtnSave(true);
        };
    }, [ issueSel ]);

    useEffect(() => {
        (async() => {
            setEditorLangs();

            let pid = await getProjects();
            setProj(pid);
            await getIssueList(pid);

            if (elTabs.current !== null) {
                //elTabs.current.setAttribute('data-tab', '1');
            };
        })();

        return () => {
            //console.log('unmount');
        };
    }, [ setEditorLangs, getProjects, getIssueList ]);

    useEffect(() => {
        //console.log('mode', mode, camera);

        initEditorContent();
       
        let curr = elTabs.current.getAttribute('data-tab');
        if (mode === 'IssueReg' && camera && camera.includes('action')) {
            if (curr === '1') {
                if (fileInputImage.current !== null) {
                    fileInputImage.current.click();
                }
            };
        } else if (mode === 'IssueReg' && camera && camera.includes('gallery')) {
            if (curr === '1') {
                if (fileInputGallery.current !== null) {
                    fileInputGallery.current.click();
                }
            };
        };
    }, [ mode, camera ]);

    if (!user.lang){
        return <Navigate replace to='/signin' />; 
    };

    const handleCloseSuccess = (event, reason) => {
        if (reason === 'clickaway') return;
        setSuccess(false);
    };
    const handleCloseFailed = (event, reason) => {
        if (reason === 'clickaway') return;
        setFailed(false);
    };

    const ContainerPics = styled(Container)(({theme}) => ({
        display: 'block',
        //direction: 'column',
        //flexGrow: 1,
        width: '100%',
        height: '100%',
        overflow: 'auto',
        //alignItems: 'center',
        //justifyContent: 'center',
        background: '#f0f8ff',
        //background: theme.palette.grey[50],
    }));
    const BoxProj = styled(Box)(({theme}) => ({
        display: 'flex',
        //flexDirection: 'column',
        //flexGrow: 1,
        //flexDirection: {
        //    xs: 'column', // mobile
        //    sm: 'row', // tablet and up
        //},
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        //borderRadius: 10,
        //background: theme.palette.white,
        //boxShadow: '0 1px 3px rgba(0, 127, 255, 0.1)',
    }));
    //const BoxImg = styled(Box)(({theme}) => ({
    //    //display: 'none',
    //    display: 'flex',
    //    width: '100%',
    //    height: '40vh',
    //    //backgroundImage: 'url(https://source.unsplash.com/random?wallpapers)',
    //    //backgroundImage: `url(${logo})`,
    //    backgroundRepeat: 'no-repeat',
    //    //backgroundColor: '#ffffff', //(t) => t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
    //    backgroundSize: 'contain',
    //    backgroundPosition: 'center',
    //    borderRadius: 5,
    //    borderColor : '#e0e0e0',
    //    borderWidth: '1px',
    //    borderStyle: 'solid',
    //}));
    
    return (
        <ContainerPics maxWidth={false} disableGutters sx={{ m:0, p:0, width: '100%', flexGrow: 1 }}>
            <Toolbar />
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs variant="fullWidth" value={tab} data-tab={tab} ref={elTabs} onChange={handleChangeTab}>
                    <Tab label={ml.ISSUE_REG} value="1" id="tab-360-1" aria-controls="tabpanel-360-1" sx={{ fontSize: 'min(16px, 3.6vmin)', fontWeight: 'bold' }} />
                </Tabs>
            </Box>
            <div role="tabpanel" hidden={tab !== '1'} id="tabpanel-360-1" aria-labelledby="tab-360-1" value="1">
                <Box sx={{ px: 2, py: 1 }}>
                    <BoxProj sx={{ m: 0 }}>
                        <FormControl variant="outlined" sx={{ mx: 0, my: 1, width: '100%' }} size="small" fullWidth>
                            <Select id="sel-projs" value={proj} onChange={handleProjs} displayEmpty sx={{ color: '#1976d2' }}>
                                { projs.current.map((p, idx) => (
                                    <MenuItem key={p.proj_id} value={p.proj_id} dense sx={{ color: '#1976d2' }}>
                                        <Typography textAlign="center" variant="subtitle2">{p.proj_nm}</Typography>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </BoxProj>
                    {/*
                    <TextField inputRef={issueRef} variant="outlined" size="small" margin="dense" required fullWidth id="issue-tab1" label={ml.ISSUE} name="Issue" 
                        inputProps={{ maxLength: 250 }} defaultValue={issue} onChange={handleChangeIssue} onBlur={handleBlurIssue}
                    />
                    */}
                    <Creatable isCreatable defaultValue={issueSel} onChange={setIssueSel} options={issueOpts} placeholder={ml.ISSUE} createOptionPosition="first"
                        noOptionsMessage={() => ('')} formatCreateLabel={(inputValue) => (`"${inputValue}"`)}
                        styles={{ menu: (styles) => ({ ...styles, zIndex: 5 }) }}
                    />
                    <FormControl variant="standard" sx={{ mx: 0, my: 0.5, p: 0, width: '100%' }} size="small" fullWidth>
                        <Select id="issue-status" value={issueStat} onChange={handleIssueStat} sx={{ m: 0, p: 0, color: '#1976d2', bgcolor: 'transparent' }}>
                            <MenuItem key="STATUS_ACTIVE" value="STATUS_ACTIVE" dense sx={{ color: '#1976d2' }}>
                                <Typography textAlign="center" variant="subtitle2">{ml.STATUS_ACTIVE}</Typography>
                            </MenuItem>
                            <MenuItem key="STATUS_COMPLETE" value="STATUS_COMPLETE" dense sx={{ color: '#1976d2' }}>
                                <Typography textAlign="center" variant="subtitle2">{ml.STATUS_COMPLETE}</Typography>
                            </MenuItem>
                        </Select>
                    </FormControl>
                    <ToggleButtonGroup color="primary" value={editorSelect} exclusive onChange={handleEditorSelect} size="small" fullWidth>
                        <ToggleButton value="issueRegist">{ml.ISSUE_REG}</ToggleButton>
                        <ToggleButton value="issueResult">{ml.RESULT}</ToggleButton>
                    </ToggleButtonGroup>
                    <Editor tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'} onInit={(e, editor) => { editorRef.current = editor; }}
                        init={editorInit} initialValue={initContent} onEditorChange={handleEditorChange} onBlur={handleBlur}
                        onContextMenu={(e) => { e.preventDefault(); }}
                    />
                    {/* initialValue={initContent} value={editorContent} onEditorChange={(newValue, editor) => setEditorContent(newValue)} */}
                    <Button variant="contained" size="small" sx={{ my: 1 }} fullWidth onClick={handleSave} disabled={btnSave}>
                        <Typography textAlign="center" variant="subtitle2">{ml.SAVE}</Typography>
                    </Button>
                    <input type="file" name="fileInputImage" id="fileInputImage" accept="image/*" capture="camera" style={{ display: 'none' }} ref={fileInputImage} onClick={handleClickImage} onInput={handleChangeImage} />
                    <input type="file" name="fileInputGallery" id="fileInputGallery" accept="*/*" style={{ display: 'none' }} ref={fileInputGallery} onClick={handleClickFile} onInput={handleChangeFile} />
                </Box>
            </div>
            <Snackbar open={success} autoHideDuration={3000} onClose={handleCloseSuccess} sx={{ opacity: 0.85 }}>
                <Alert onClose={handleCloseSuccess} severity="success" sx={{ width: '100%', backgroundColor: 'rgba(40, 40, 40, 0.85)' }} elevation={6} variant="filled">
                    Successfully completed!
                </Alert>
            </Snackbar>
            <Snackbar open={failed} autoHideDuration={3000} onClose={handleCloseFailed} sx={{ opacity: 0.85 }}>
                <Alert onClose={handleCloseFailed} severity="error" sx={{ width: '100%', backgroundColor: 'rgba(40, 40, 40, 0.85)' }} elevation={6} variant="filled">
                    Failed!
                </Alert>
            </Snackbar>
            { loading && 
                <Modal open={loading}>
                    <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                        <PulseLoader loading={loading} color="#36d7b7" height={30} />
                    </Box>
                </Modal>
            }
            <BottomNavigation value="" sx={{ display: 'block', minHeight: '56px', background: 'none' }} />
        </ContainerPics>
    );
};

export default IssueReg;


